import React, { useEffect, useState } from "react";
import {
  Layout,
  Input,
  Avatar,
  Badge,
  Space,
  Dropdown,
  Menu,
  Drawer,
  Button,
  Modal,
  Row,
  Col,
  Form,
  message
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  SearchOutlined,
  BellOutlined,
  MessageOutlined,
  CalendarOutlined,
  MoreOutlined,
  MenuOutlined,
  HomeOutlined,
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import { AuthProvider, useAuth } from "../../hooks/AuthContext";
import { Link } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";

const { Header } = Layout;

interface HeaderProps {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  title?: string;
}

const AppHeader: React.FC<HeaderProps> = ({ collapsed, setCollapsed, title }) => {
  const { user, logout } = useAuth();
  const currentUser = user || JSON.parse(localStorage.getItem("user") || "{}");
  const [formChangePassword] = Form.useForm();
  const [formChangeVersion] = Form.useForm();

  const [isOpenChangePassWord, setOpenChangePassWord] = useState(false);
  const [isOpenChangeVersion, setOpenChangeVersion] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    updateIsMobile();
    window.addEventListener("resize", updateIsMobile);
    return () => window.removeEventListener("resize", updateIsMobile);
  }, []);


  const handleOpenChangePassword = () => {
    setOpenChangePassWord(true);
  };
  const handleOpenChangeVersion = () => {
    setOpenChangeVersion(true);
  };

  const handleCancelChangePassword = () => {
    setOpenChangePassWord(false);
    formChangePassword.resetFields();
  };
  const handleCancelChangeVersion = () => {
    setOpenChangeVersion(false);
    formChangeVersion.resetFields();
  };

  const handleChangePassword = async () => {
    try {
      const values = formChangePassword.getFieldsValue();
      const payload = {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      }
      await axiosInstance.put(`/user/change-password`, payload);
      message.success("Đổi mật khẩu thành công!");
      handleCancelChangePassword();
      logout();
    } catch (error: any) {
      message.error(error?.response?.data.systemMessage);
    }
  }

  const handleChangeVersion = async () => {
    try {
      const values = formChangeVersion.getFieldsValue();
      const payload = {
        versionByAndroid: values.versionByAndroid,
        versionByIos: values.versionByIos,
      }
      
      await axiosInstance.put(`/versions/update-version`, payload);
      message.success("Cập nhật version thành công!");
      handleCancelChangeVersion();
    } catch (error: any) {
      message.error(error?.response?.data.systemMessage);
    }
  }
  const menu = (
    <Menu>
      <Menu.Item key="profile">Hồ sơ</Menu.Item>
      <Menu.Item key="change-password" onClick={handleOpenChangePassword}>Đổi mật khẩu</Menu.Item>
      <Menu.Item key="change-version" onClick={handleOpenChangeVersion}>Cập nhật version</Menu.Item>
      <Menu.Item key="logout" onClick={logout}>
        Đăng xuất
      </Menu.Item>
    </Menu>
  );

  const sidebarMenu = (
    <Menu theme="light" mode="inline" onClick={() => setDrawerVisible(false)}>
      <Menu.Item key="1" icon={<HomeOutlined />} style={{ fontSize: 18, fontWeight: '400' }}>
        <Link to="/tournament">Giải đấu</Link>
      </Menu.Item>
      {/* <Menu.Item key="2" icon={<UserOutlined />} style={{ fontSize: 18, fontWeight: '400' }}>
        <Link to="/user-management">Quản lý người dùng</Link>
      </Menu.Item> */}
      {/* <Menu.Item key="3" icon={<SettingOutlined />} style={{ fontSize: 18, fontWeight: '400' }}>
        <Link to="/settings">Cài đặt</Link>
      </Menu.Item> */}
      <Menu.Item
        key="4"
        icon={<LogoutOutlined />}
        style={{ fontSize: 18, fontWeight: '400' }}
        onClick={() => {
          logout();
          setDrawerVisible(false);
        }}
      >
        Đăng xuất
      </Menu.Item>
    </Menu>

  );

  return (
    <>
      <Header
        style={{
          background: "#fff",
          padding: "0 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #ddd",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          position: "sticky",
          top: 0,
          zIndex: 1000,
          marginLeft: isMobile ? 0 : collapsed ? "80px" : "200px",
        }}
      >
        {/* Trái */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {isMobile ? (
            <MenuOutlined
              style={{ fontSize: 20, cursor: "pointer" }}
              onClick={() => setDrawerVisible(true)}
            />
          ) : collapsed ? (
            <MenuUnfoldOutlined
              onClick={() => setCollapsed(false)}
              style={{ fontSize: 18, cursor: "pointer" }}
            />
          ) : (
            <MenuFoldOutlined
              onClick={() => setCollapsed(true)}
              style={{ fontSize: 18, cursor: "pointer" }}
            />
          )}

          <span style={{ fontWeight: "bold", fontSize: 18 }}>{title}</span>
        </div>

        {/* Phải */}
        <Space size="large">
          {!isMobile && (
            <>
              <Input
                placeholder="Tìm kiếm"
                prefix={<SearchOutlined />}
                style={{ width: 200 }}
              />
              <Badge count={5}>
                <CalendarOutlined style={{ fontSize: 20, cursor: "pointer" }} />
              </Badge>
              <Badge count={2}>
                <MessageOutlined style={{ fontSize: 20, cursor: "pointer" }} />
              </Badge>
              <Badge count={3}>
                <BellOutlined style={{ fontSize: 20, cursor: "pointer" }} />
              </Badge>
              <Dropdown overlay={menu} trigger={["click"]}>
                <Space style={{ cursor: "pointer" }}>
                  <span>{currentUser.username || "Người dùng"}</span>
                  <Avatar style={{ backgroundColor: "#f56a00" }}>
                    {currentUser.username?.charAt(0).toUpperCase() || "?"}
                  </Avatar>
                </Space>
              </Dropdown>
            </>
          )}
        </Space>
        <Modal
          title="Đổi mật khẩu"
          open={isOpenChangePassWord}
          onCancel={handleCancelChangePassword}
          width={500}
          footer={[
            <Button key="cancel" style={{ backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} onClick={handleCancelChangePassword}>
              Thoát
            </Button>,
            <Button key="submit" type="primary" style={{ backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={handleChangePassword}>
              Lưu
            </Button>,
          ]}
        >
          <Form layout="vertical" form={formChangePassword}>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label="Nhập mật khẩu cũ"
                  name="currentPassword"
                  rules={[
                    { required: true, message: "Vui lòng nhập mật khẩu!" }
                  ]}
                >
                  <Input.Password
                    placeholder="Nhập mật khẩu"
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Nhập mật khẩu mới"
                  name="newPassword"
                  rules={[
                    { required: true, message: "Vui lòng nhập mật khẩu!" },
                    { min: 6, message: "Mật khẩu phải có ít nhất 6 ký tự!" },
                  ]}
                >
                  <Input.Password
                    placeholder="Nhập mật khẩu"
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Nhập lại mật khẩu"
                  name="confirmPassword"
                  dependencies={["newPassword"]}
                  rules={[
                    { required: true, message: "Vui lòng nhập lại mật khẩu!" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Mật khẩu nhập lại không khớp!"));
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    placeholder="Nhập lại mật khẩu"
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>

        <Modal
          title="Cập nhật version"
          open={isOpenChangeVersion}
          onCancel={handleCancelChangeVersion}
          width={500}
          footer={[
            <Button key="cancel" style={{ backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} onClick={handleCancelChangeVersion}>
              Thoát
            </Button>,
            <Button key="submit" type="primary" style={{ backgroundColor: "#F48100", borderColor: "#F48100" }} onClick={handleChangeVersion}>
              Lưu
            </Button>,
          ]}
        >
          <Form layout="vertical" form={formChangeVersion}>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label="Nhập version android"
                  name="versionByAndroid"
                >
                  <Input
                    placeholder="Nhập version android"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Nhập version ios"
                  name="versionByIos"
                >
                  <Input
                    placeholder="Nhập version ios"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Header>

      {/* Drawer Menu cho mobile */}
      {isMobile && (
        <Drawer
          placement="left"
          visible={drawerVisible}
          onClose={() => setDrawerVisible(false)}
          bodyStyle={{ padding: 0 }}
        >
          {/* Menu trái */}
          {sidebarMenu}
        </Drawer>
      )}

    </>
  );
};

export default AppHeader;
